import React, {useState} from 'react';
import blockStyles from '@baseStyles/block.scss';
import styles from './FAQ.scss';
import {useScreenSizeBelowBreakpoint} from "@hooks/useScreenSizeBelowBreakpoint";

const FAQ = ({data, color = '', size, opened = false}) => {

	if (!data.blockContent) {
		return null;
	}

	const [openedAnswers, setOpenedAnswers] = useState(new Set());
	const isLessThan1200 = useScreenSizeBelowBreakpoint(1200);

	const toggleAnswer = (answer) => {
		setOpenedAnswers((prev) => {
			const newSet = new Set(prev);
			if (newSet.has(answer)) {
				newSet.delete(answer); // Close if opened
			} else {
				newSet.add(answer); // Open if closed
			}
			return newSet;
		});
	};

	let sizeClassMap = {
		'900': blockStyles.w900
	}

	return (
	  <div className={`${blockStyles.baseContainerHolder} mt0`}>
		  <div className={`${styles.container} ${sizeClassMap[size] ? sizeClassMap[size] : ''}`}>
			  {data.blockContent.map((val, k) => {
				  const isOpen = opened || openedAnswers.has(k);

				  return (
					<div
					  className={`${styles.questionHolder} ${opened ? styles.static : ''} ${color ? styles[color] : ''}`}
					  key={k}
					  onClick={opened ? null : () => toggleAnswer(k)}
					  onKeyDown={opened ? null : (e) => {
						  if (e.key === 'Enter' || e.key === ' ') {
							  e.preventDefault();
							  toggleAnswer(k);
						  }
					  }}>
						<div
						  className={'cursorDefault'}
						  onClick={!isLessThan1200 ? (e) => e.stopPropagation() : null}>
							<div className={styles.circle}></div>
						</div>
						<div>
							<h2
							  tabIndex={opened ? undefined : 0}
							  //onClick={() => toggleAnswer(k)}
							  className={styles.question}>
								{val.question}
							</h2>

							<div
							  onClick={!isLessThan1200 ? (e) => e.stopPropagation() : null}
							  className={`${styles.text} ${isOpen ? styles.opened : ''}`}
							  dangerouslySetInnerHTML={{__html: val.answer}}>
							</div>
						</div>
					</div>
				  );
			  })}
		  </div>
	  </div>
	)
}

export default FAQ;
